import type { NotificacaoDto } from '@crm/shared'
import { useCancelarAgendadasDaConversa, useDispensarNotificacao } from '../api/hooks-operacao'
import { juntar } from './ui'

/**
 * Os botões próprios de alguns avisos, no cartão da barra e na tela de
 * Notificações.
 *
 * Hoje só o "cliente respondeu antes da mensagem programada" (mapa de uso,
 * 08/10/2026): o Mike escolheu o aviso "com Manter ou Cancelar". Manter só
 * dispensa o aviso, e a mensagem sai na hora marcada; Cancelar desmarca as
 * mensagens que a pessoa programou para esse cliente e dispensa o aviso.
 */
export function AcoesDoAviso({
  notificacao,
  classeDoBotao,
}: {
  notificacao: NotificacaoDto
  classeDoBotao?: string
}) {
  const dispensar = useDispensarNotificacao()
  const cancelar = useCancelarAgendadasDaConversa()

  if (notificacao.tipo !== 'agendada_respondida' || !notificacao.entidadeId) return null
  if (notificacao.dispensadaEm) return null
  const ocupado = dispensar.isPending || cancelar.isPending
  const chamadoId = notificacao.entidadeId

  return (
    <span className="mt-1 flex flex-wrap gap-3">
      <button
        type="button"
        disabled={ocupado}
        onClick={() => dispensar.mutate(notificacao.id)}
        className={juntar('text-xs font-medium underline disabled:opacity-50', classeDoBotao)}
      >
        Manter a mensagem
      </button>
      <button
        type="button"
        disabled={ocupado}
        onClick={() =>
          cancelar.mutate(chamadoId, { onSuccess: () => dispensar.mutate(notificacao.id) })
        }
        className={juntar('text-xs font-medium underline disabled:opacity-50', classeDoBotao)}
      >
        {cancelar.isPending ? 'Cancelando…' : 'Cancelar a mensagem'}
      </button>
    </span>
  )
}
